/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-03-07 11:09:52
 * @LastEditors: yuanxing(01407381)
 * @LastEditTime: 2023-05-19 14:59:49
 * @FilePath: \ibu-owt-core-frontend\site\country\sg\index.js
 * @Description:
 */
// import Index from './index/index.vue'
// import Consign from './consign/index.vue'
// import Product from './product/index.vue'
// import Contact from './contact/index.vue'
// import Dept from './dept/index.vue'
// import Invoice from './invoice/index.vue'

// export const pages = {
//   index: Index,
//   consign: Consign,
//   product: Product,
//   contact: Contact,
//   dept: Dept,
//   invoice: Invoice, // 发票申请
// }

export const pages = {
  index: () => import('./index/index.vue'), // 首页
  consign: () => import('./consign/index.vue'), // 服务支持 寄件流程指引
  product: () => import('./product/index.vue'), // 物流服务 物流产品详情
  contact: () => import('./contact/newIndex.vue'), // 联系我们
  dept: () => import('./dept/index.vue'), // 服务网点
  invoice: () => import('./invoice/index.vue'), // 发票申请
}
